<template>
  <div class="page-content-wrapper" v-check-permission="'registration-to-examination-tables'">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card m-b-20">
            <div class="card-block">
              <h4 class="mt-0 header-title">Inscripción a mesas de exámen</h4>

              <template v-if="error">
                <div class="ex-page-content text-center">
                  <h1>!Upsss!</h1>
                  <span><i class="fa fa-meh-o icon"></i></span>
                  <h5 class="text-muted"><span v-html="this.error"></span></h5>
                  <p class="text-muted mt-3">Intenta nuevamente mas tarde, o comunícate con el área de informática del instituto.</p>
                  <p class="text-muted">Para volver a intentarlo presiona el siguiente botón:</p>

                  <a class="btn btn-info" href="javascript:void(0);" @click="getRegistrationToExaminationTables()">Volver a intentar</a>
                </div>
              </template>

              <template v-if="registrationToExaminationTables && registrationToExaminationTables.examinationTable && !error">

                <div style="background: rgb(245, 246, 249);" v-if="registrationToExaminationTables.examinationTable && registrationToExaminationTables.examinationTable.name" class="alert alert-danger alert-dismissible fade show text-muted mt-3 text-center font-14 mb-1">
                  <h4 class="alert-heading font-18">{{ registrationToExaminationTables.examinationTable.name }}</h4>
                  <p v-if="registrationToExaminationTables.examinationTable.called">{{registrationToExaminationTables.examinationTable.called}}</p>
                  <p v-if="registrationToExaminationTables.examinationTable.description">{{ registrationToExaminationTables.examinationTable.description }}</p>

                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-4" v-if="registrationToExaminationTables.examinationTable.publishListsFrom || registrationToExaminationTables.examinationTable.publishListsTo">
                      <h6>Fecha de publicación de las listas:</h6>
                      <span v-if="registrationToExaminationTables.examinationTable.publishListsFrom"><strong>Desde: </strong>{{ registrationToExaminationTables.examinationTable.publishListsFrom | formatDate("DD/MM/YYYY") }}</span>
                      <span v-if="registrationToExaminationTables.examinationTable.publishListsTo"><strong>Hasta: </strong>{{ registrationToExaminationTables.examinationTable.publishListsTo | formatDate("DD/MM/YYYY") }}</span>
                    </div>
                    <div class="col-md-4" v-if="registrationToExaminationTables.examinationTable.examsFrom || registrationToExaminationTables.examinationTable.examsTo">
                      <h6>Fecha de las mesas:</h6>
                      <span v-if="registrationToExaminationTables.examinationTable.examsFrom"><strong>Desde: </strong>{{ registrationToExaminationTables.examinationTable.examsFrom | formatDate("DD/MM/YYYY") }}</span>
                      <span v-if="registrationToExaminationTables.examinationTable.examsTo"><strong>Hasta: </strong>{{ registrationToExaminationTables.examinationTable.examsTo | formatDate("DD/MM/YYYY") }}</span>
                    </div>
                    <div class="col-md-2"></div>
                  </div>
                </div>

                <div class="alert alert-success alert-dismissible fade show mt-1 text-center font-14" v-if="registrationToExaminationTables && registrationToExaminationTables.registrationToExaminationTable">
                  Ya estas inscripto/a.
                </div>
                <div class="mt-5" v-else>Seleccioná las materias, y luego haz click en el botón <i>INSCRIBIRME</i>:</div>

                <div class="row  mt-4" v-if="studyPlan && studyPlan.levels">
                  <div class="col-md-4" v-for="level in studyPlan.levels">

                    <h5 class="mt-0 header-title">{{ level.value}} - {{ level.name }}</h5>

                    <div class="form-group  m-b-0">
                      <div v-for="subject in level.subjects">
                        <label class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" v-bind:disabled="registrationToExaminationTables && registrationToExaminationTables.registrationToExaminationTable" v-bind:value="subject._id" v-model="registration.subjects">
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-description">{{ subject.curricularSpace }} <small>({{ getSubjectDuration(subject.duration) }})</small></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group"  v-bind:class="{ 'has-danger': $v.registration.subjects.$error }">
                  <div class="form-control-feedback" v-if="!$v.registration.subjects.required && $v.registration.subjects.$error">Debes seleccionar al menos una materia para poder inscribirte.</div>
                </div>

                <div class="col-6 mb-3" style="background: rgb(238, 138, 139); padding: 10px;"><h5 style="color: rgb(255, 255, 255);">Información importante:</h5>
                  <p style="color: rgb(255, 255, 255);">
                    Una vez enviado el formulario ya no podras editar la inscripción a la mesa.<br>
                    Asegurate de haber seleccionado las materias correctas antes de enviarlo.
                  </p>
                </div>

                <div class="card-block pull-right pr-0" v-if="registrationToExaminationTables && !registrationToExaminationTables.registrationToExaminationTable">
                  <router-link to="/" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Inscribirme</a>
                </div>

              </template>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import { addRegistrationToExaminationTables } from '../api'
  import subjectDuration from '../data/subjectDuration'

  export default {
    name: 'registration-to-examination-tables',

    created () {
      this.getRegistrationToExaminationTables()
    },


    data () {
      return {
        studyPlan: null,
        error: null,
        subjectDuration: subjectDuration,
        registration: {
          subjects: [],
          career: null,
          examinationTable: null,
          user: this.$store.state.auth.user._id
        }
      }
    },


    computed: {
      registrationToExaminationTables: function () {
        return this.$store.getters.getRegistrationToExaminationTables
      }
    },


    validations: {
      registration: {
        subjects: {
          required
        },
        career: {
          required
        },
        examinationTable: {
          required
        },
        user: {
          required
        }
      }
    },


    methods: {
      submit: function () {

        const self = this;
        this.$v.registration.$touch();

        if(!this.$v.registration.$error) {

          $('.save-btn').attr('disabled', true);

          addRegistrationToExaminationTables(this.registration)
            .then((response) => {
              if(response.body.success) {
                self.getRegistrationToExaminationTables();
              } else {
                self.$message.error({text: response.message});
              }
              $('.save-btn').attr('disabled', false);
              self.$html.gotoTop();
            })
            .catch((response) => {
              self.$message.error({text: response.message});
              $('.save-btn').attr('disabled', false);
            })

        }

      },


      getRegistrationToExaminationTables: function () {
        const self = this;
        this.$loader.loading();
        this.$store.dispatch('getRegistrationToExaminationTables')
          .then((response) => {
            if(response.success) {
              this.error = null;
              if(response.data.studyPlan) {
                self.getStudyPlan(response.data.studyPlan);
              } else {
                //self.getDefaultStudyPlan();
              }
              self.registration.career = response.data.career;
              self.registration.examinationTable = response.data.examinationTable;
              if(response.data && response.data.registrationToExaminationTable && response.data.registrationToExaminationTable.subjects) {
                self.registration.subjects = response.data.registrationToExaminationTable.subjects;
              }
            } else {
              self.error = response.message;
            }
            this.$loader.close();

          })
          .catch(response => {
            self.error = response.message;
            this.$loader.close();
          })
      },

      getStudyPlan: function (id) {
        var studyPlans = this.registrationToExaminationTables.career.studyPlans.filter(item => (item._id === id));
        if(studyPlans && studyPlans.length > 0) {
          this.studyPlan = studyPlans[0];
        }
      },

      getDefaultStudyPlan: function () {
        var studyPlans = this.registrationToExaminationTables.career.studyPlans.filter(item => (item.isDefault === true));
        if(studyPlans && studyPlans.length > 0) {
          this.studyPlan = studyPlans[0];
        }
      },

      getSubjectDuration: function (key) {
        var subjectDuration = this.subjectDuration.filter(function (item) {
          return key === item.value;
        });
        if(subjectDuration && subjectDuration.length > 0) {
          return subjectDuration[0].text;
        }
        return '--';
      }

    }
  }
</script>

<style scoped>
  h1 {
    font-size: 3em;
    line-height: normal;
    text-shadow: none;
  }
  .icon {
    font-size: 47px;
  }
  .card {
    min-height: 80vh;
  }
  .ex-page-content {
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/RegistrationToExaminationTablesScreen.vue